module.exports = __webpack_public_path__ + "static/img/notcorrect.c62138b1.png";